import { ticoticketApi } from "../ticoticketApi";
import Cookies from "js-cookie";

export const getPlannerUserClients = async () => {
  const token = Cookies.get("token");

  try {
    const { data } = await ticoticketApi.get("/planner/clients", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { ok: true, data };
  } catch (error: any) {
    console.error("Error obteniendo los eventos:", error);
    return {
      ok: false,
      errorMessage: error.response?.data,
    };
  }
};
